import React from 'react'
import "./Gallery.css";

const normalizeImageUrl = (url) => {
  if (typeof url !== "string") {
    return url;
  }

  try {
    const imageUrl = new URL(url);

    if (imageUrl.hostname === "via.placeholder.com") {
      const pathParts = imageUrl.pathname.split("/").filter(Boolean);

      // Placehold requires background and text colors to be specified together.
      if (pathParts.length === 2) {
        pathParts.push("000000");
        imageUrl.pathname = `/${pathParts.join("/")}/`;
      }

      imageUrl.protocol = "https:";
      imageUrl.hostname = "placehold.co";
      return imageUrl.toString();
    }
  } catch (error) {
    // Keep relative or otherwise non-standard image URLs unchanged.
  }

  return url;
};

const Gallery = (props) => {
  return (
    <div id="imgsContainer">
        {props.imgList.map((elemento, index) => (
          <div className="col-12 col-md-4 imgContainer1a" key={index}>
            <div className="imgContainer1b">
              <img className="galleryImage" src={normalizeImageUrl(elemento.url)}></img>
              <p className="galleryImage-description">{elemento.description}</p>
              <div className="galleryImage-cover"></div>
            </div>
          </div>
        ))}
    </div>
  )
}

export default Gallery
